const initialState = {
  cityOperatorsList: { items: [], totalItems: 0 },
  isSettlementCycleSaved: { success: false },
};
export default initialState;
